module.exports = __webpack_public_path__ + "img/full_right_angle_corner_line.7b92dc84.svg";